'use client';

import { useState } from 'react';
import Image from 'next/image';
import { cn } from '@/lib/utils';

interface ZoomableArticleImageProps {
  src: string;
  alt: string;
}

export default function ZoomableArticleImage({ src, alt }: Readonly<ZoomableArticleImageProps>) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <button
      type="button"
      aria-label={`${isExpanded ? 'Réduire' : 'Agrandir'} l’image : ${alt}`}
      aria-pressed={isExpanded}
      onClick={() => setIsExpanded((expanded) => !expanded)}
      className={cn(
        'not-prose relative my-8 block border-0 bg-transparent p-0 transition-all duration-300 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-600',
        isExpanded
          ? 'left-1/2 w-[min(1200px,calc(100vw-2rem))] -translate-x-1/2 cursor-zoom-out'
          : 'w-full cursor-zoom-in',
      )}
    >
      <span className="relative block aspect-video w-full overflow-hidden rounded-3xl bg-gray-100 shadow-lg ring-1 ring-black/5">
        <Image
          src={src}
          alt={alt}
          fill
          sizes={isExpanded ? '(max-width: 1240px) calc(100vw - 2rem), 1200px' : '896px'}
          className="object-contain"
        />
      </span>
    </button>
  );
}
